import { Directive, Input, TemplateRef, ViewContainerRef } from '@angular/core';
import { enableDisableView } from './if-feature-flag-enabled.directive';
import { WebAngularSharedDataAccessFeatureFlagApisService } from '../services/feature-flags.service';

@Directive({
  selector: '[appIfFeatureFlagDisabled]'
})
export class IfFeatureFlagDisabledDirective {
  private currentViewState = false;
  private flagValue: boolean;

  @Input()
  set appIfFeatureFlagDisabled(flagName: string) {
    this.flagValue = this.featureFlagService.getFlag(flagName);
    const enableView = !this.flagValue;

    this.currentViewState = enableDisableView(
      enableView,
      this.viewContainer,
      this.templateRef,
      this.currentViewState
    );
  }

  constructor(
    private templateRef: TemplateRef<any>,
    private viewContainer: ViewContainerRef,
    private featureFlagService: WebAngularSharedDataAccessFeatureFlagApisService
  ) {}
}
